<template>
  <v-container>
    <div class="display-2">このブラウザはサポートされていません</div>
    <ul>
      <li>{{ navigator.appVersion }}</li>
      <li>navigator.mediaDevices:{{ navigator.mediaDevices }}</li>
      <li>getDisplayMedia:{{ navigator.mediaDevices.getDisplayMedia }}</li>
      <li>getUserMedia:{{ navigator.mediaDevices.getUserMedia }}</li>
    </ul>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      navigator: navigator
    };
  },
  methods: {
    getDisplayMedia() {
      navigator.mediaDevices
        .getDisplayMedia({
          video: true,
          audio: false
        })
        .catch(e => {
          console.log(e);
        });
    },
    getUserMedia() {
      navigator.mediaDevices
        .getUserMedia({
          video: false,
          audio: true
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
